import React, { lazy } from 'react';
import { BookOpenIcon, ListChecksIcon, GiftIcon, TagIcon } from 'lucide-react';
const stats = [{
  icon: BookOpenIcon,
  number: '300+',
  label: 'Natural Remedies'
}, {
  icon: ListChecksIcon,
  number: '66',
  label: 'Conditions Covered'
}, {
  icon: GiftIcon,
  number: '5',
  label: 'Free Bonuses'
}, {
  icon: TagIcon,
  number: '$27',
  label: 'One Time Only'
}];
export function StatsBar() {
  return <section className="bg-primary-light/10 border-y border-primary/10 py-4 md:py-6" data-id="element-267">
      <div className="max-w-5xl mx-auto px-4" data-id="element-268">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8" data-id="element-269">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-270">
              <stat.icon className="w-8 h-8 mx-auto mb-2 text-primary" data-id="element-271" />
              <div className="font-heading text-2xl md:text-3xl font-bold text-dark" data-id="element-272">
                {stat.number}
              </div>
              <div className="text-muted text-sm font-medium" data-id="element-273">{stat.label}</div>
            </div>)}
        </div>

        {/* Testimonial */}
        <div className="mt-6 md:mt-10 max-w-xl mx-auto" data-id="element-274">
          <div className="relative rounded-xl overflow-hidden shadow-lg" data-id="element-275">
            <img src="https://cdn.magicpatterns.com/uploads/5Aj8Cf77ePhXVLaozd7cvC/Captura_de_pantalla_2026-03-09_a_las_14.24.33.jpg" alt="Facebook testimonial from Sarah Miller about The Home Healing Handbook" className="w-full block" loading="lazy" data-id="element-276" />
            <div className="absolute inset-0 rounded-xl pointer-events-none" style={{
            boxShadow: 'inset 0 0 40px 10px rgba(0,0,0,0.12)'
          }} data-id="element-277" />
            <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/15 to-transparent pointer-events-none" data-id="element-278" />
            <div className="absolute inset-x-0 top-0 h-10 bg-gradient-to-b from-black/10 to-transparent pointer-events-none" data-id="element-279" />
          </div>

          <p className="text-dark/60 text-sm mt-3 md:mt-4 text-center font-medium tracking-wide" data-id="element-280">
            — Review from Sarah💞 , Mother of 3
          </p>
        </div>
      </div>
    </section>;
}